export default {
  auth: 'auth',
  currentLandlordAssessment: 'currentLandlordAssessment',
  dashboard: 'dashboard',
  handleMagicLink: 'handleMagicLink',
  home: 'home',
  linkExpired: 'linkExpired',
  login: 'login',
  newLandlord: 'newLandlord',
  newLandlordAssessment: 'newLandlordAssessment',
  newLandlordLogin: 'newLandlordLogin',
  notFound: 'notFound',
  reIssueRequest: 'reIssueRequest',
  requestCurrentLandlord: 'requestCurrentLandlord',
  requestNewLandlord: 'requestNewLandlord',
  requestNewLandlordCheck: 'requestNewLandlordCheck',
  settings: 'settings',
  settingsNotification: 'settings-notification',
  settingsOrganisation: 'settings-organisation',
  settingsOrganisationDetail: 'settings-organisation-detail',
  settingsOrganisationOverview: 'settings-organisation-overview',
  tenantCheck: 'tenantCheck',
  tenantDashboard: 'tenantDashboard',
  viewDeclaration: 'viewDeclaration',
  // WoningNet SSO routes
  woningNet: 'woningNet',
  woningNetCallback: 'woningNetCallback',
};
